module.exports = __webpack_public_path__ + "assets/move.fdedc1b2.svg";